import { DefaultUrlSerializer, UrlTree } from '@angular/router';
import { Injectable } from "@angular/core";
/**
 * 處理html後綴的自定義UrlSerializer，會在頁面的RouterLink產生對應的href屬性時執行
 * 將.html後綴移到最後面
 */
@Injectable()
export class HtmlSuffixURLSerializer extends DefaultUrlSerializer {
  // parse(url: string): UrlTree {
  //   const defaultUrlTree = super.parse(url);
  //   return defaultUrlTree;
  // }
  override serialize(tree: UrlTree): string {
    // 先取得預設Serialize的結果（此時.html後綴根據當前頁面可能會在中間或者不存在）
    const defaultUrl = super.serialize(tree);
    // 匹配是否存在.html後綴
    const hasHtmlSuffixRegex = /\.html/;
    // 如果存在.html後綴，則再進行網址分組的匹配，以.html為中心，分出前面網址、後面網址以及最後方的查詢參數
    const replaceCenterHtmlSuffix = /([^.]+)(?:\.html)([^?#]*)(\?.*)?(#.*)?$/;
    if (hasHtmlSuffixRegex.test(defaultUrl)) {
      const match = replaceCenterHtmlSuffix.exec(defaultUrl);
      if (match[4] === '#gsc.tab=0') {
        return defaultUrl.replace(replaceCenterHtmlSuffix, '$1$2.html$3');
      }
      // 將前面網址跟後面網址合併，再加上.html後綴，最後再加上最後方的查詢參數（如果存在的話）
      return defaultUrl.replace(replaceCenterHtmlSuffix, '$1$2.html$3$4');
    }
    // 如果沒有.html後綴，則直接加上.html後綴
    return `${defaultUrl}`;
  }

}

